import { StockAdjustmentListFilters } from "@/models/api/barcodeSystem/stockAdjustments/get";

export function defaultStockAdjustmentFilters(): StockAdjustmentListFilters {
  return {
    id: null,
    facilityCodes: null,
    createdDate:null,
    appliedDate: null,
    createdByUsername: null,
    appliedByUsername: null
  } as StockAdjustmentListFilters;
}
